__turbopack_context__.v({
  "page-link": "ListingPageLink-module-scss-module__oVWSea__page-link",
});
